/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQuery } from 'react-query'

import type { QueryHook, QueryHookOptions } from '@modules/query/types'
import { getBillingCloudResourcesV1 } from '@modules/billing-api/v1/callers'
import type { operations } from '@modules/billing-api/v1/types'

import { defaultBillingOptions } from './constants'

const QUERY_KEY = 'getBillingCloudResourcesV1'

type GetBillingCloudResourcesVariables = {
  organizationId: operations['getBillingCloudResourcesV1']['parameters']['path']['organization_id']
}

const useGetBillingCloudResources: QueryHook<typeof getBillingCloudResourcesV1> = (
  organizationId: GetBillingCloudResourcesVariables['organizationId'],
  options?: QueryHookOptions,
) =>
  useQuery(
    [QUERY_KEY, organizationId],
    () => getBillingCloudResourcesV1({ pathParameters: { organization_id: organizationId } }),
    {
      ...defaultBillingOptions,
      ...options,
      enabled: Boolean(organizationId),
    },
  )

export default useGetBillingCloudResources
